import {
  AvailableIntegrationsDocument,
  IntegrationsCapabilityModeEnum,
  IntegrationsCapabilityTypeEnum,
  MarketplaceDbIntegration,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export interface AvailableIntegrationViewModel {
  capabilityMode: IntegrationsCapabilityModeEnum
  marketplaceIntegration: MarketplaceDbIntegration
}

export const useAvailableIntegration = (
  capabilityType: IntegrationsCapabilityTypeEnum
): AvailableIntegrationViewModel | null => {
  const { data } = useQuery(AvailableIntegrationsDocument, {
    variables: {
      capabilityType,
    },
  })

  const node = data?.integrations?.availableIntegrationsConnection.nodes[0]

  if (!node) return null

  return {
    capabilityMode: node.capabilityMode,
    marketplaceIntegration: node.marketplaceIntegration,
  }
}
